
export class FadeLED {
    LED1Fade: number;
    LED2Fade: number;
    LED3Fade: number;
    LED4Fade: number;
    LED5Fade: number;
    Delay: number;

    constructor() {
        this.LED1Fade = 0;
        this.LED2Fade = 0;
        this.LED3Fade = 0;
        this.LED4Fade = 0;
        this.LED5Fade = 0;
        this.Delay = 0;
    }
}

export class StaticLed {
    LED1: boolean;
    LED2: boolean;
    LED3: boolean;
    LED4: boolean;
    LED5: boolean;
    Delay: number;

    constructor() {
        this.LED1 = true;
        this.LED2 = true;
        this.LED3 = true;
        this.LED4 = true;
        this.LED5 = true;
        this.Delay = 0;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Models/LedModels.ts
 **/